import React, { useState, useEffect } from 'react';

export default function UpdateName({ onClose, onUpdateCampaignName, currentName }) {
  const [campaignName, setCampaignName] = useState(currentName || "");

  useEffect(() => {
    setCampaignName(currentName || "");
  }, [currentName]);

  function onSubmit(event) {
    event.preventDefault();

    if (!campaignName) {
      alert("Please fill in all fields.");
      return;
    }

    onUpdateCampaignName(campaignName);
    onClose();
  }

  return (
    <>
      <div className="px-5 py-4">
        <div className="text-sm">
          <p style={{color: '#95A5A6', fontFamily: '"Share Tech Mono", monospace'}}>
            This name is for your internal use only and will not be visible to end-users.
          </p>
          <form id="campaignName" onSubmit={onSubmit}>
            <div className="mt-3">
              <label htmlFor="campaignName" className="sr-only">Name</label>
              <input
                type="text"
                name="campaignName"
                id="campaignName"
                maxLength={50}
                className="block w-full rounded-lg border-2 py-3 px-4 shadow-sm transition-all duration-200"
                placeholder="Campaign Name"
                value={campaignName}
                onChange={(e) => setCampaignName(e.target.value)}
                style={{
                  background: 'linear-gradient(135deg, #2C3E50, #34495E)',
                  border: '2px solid rgba(241, 196, 15, 0.4)',
                  color: '#ECF0F1',
                  fontFamily: '"Share Tech Mono", monospace',
                  fontSize: '14px',
                  fontWeight: 'bold'
                }}
                onFocus={(e) => {
                  e.target.style.borderColor = '#F1C40F';
                  e.target.style.boxShadow = '0 0 0 2px rgba(241, 196, 15, 0.2)';
                }}
                onBlur={(e) => {
                  e.target.style.borderColor = 'rgba(241, 196, 15, 0.4)';
                  e.target.style.boxShadow = 'none';
                }}
              />
            </div>
          </form>
        </div>
      </div>
      <div className="px-5 py-4" style={{borderTop: '2px solid rgba(241, 196, 15, 0.2)'}}>
        <div className="flex flex-wrap justify-end space-x-2">
          <button
            className="px-4 py-2 rounded-lg font-bold transition-all duration-200 hover:scale-105"
            onClick={onClose}
            style={{
              background: 'rgba(149, 165, 166, 0.2)',
              border: '2px solid rgba(149, 165, 166, 0.4)',
              color: '#95A5A6',
              fontFamily: '"Share Tech Mono", monospace'
            }}
            onMouseEnter={(e) => {
              e.target.style.background = 'rgba(149, 165, 166, 0.3)';
            }}
            onMouseLeave={(e) => {
              e.target.style.background = 'rgba(149, 165, 166, 0.2)';
            }}
          >
            CANCEL
          </button>
          <button
            type="submit"
            form="campaignName"
            className="px-4 py-2 rounded-lg font-bold transition-all duration-200 hover:scale-105"
            disabled={!campaignName}
            style={{
              background: !campaignName 
                ? 'rgba(241, 196, 15, 0.3)' 
                : 'linear-gradient(135deg, #F1C40F, #F39C12)',
              border: '2px solid #F1C40F',
              color: !campaignName ? '#95A5A6' : '#2C3E50',
              cursor: !campaignName ? 'not-allowed' : 'pointer',
              fontFamily: '"Share Tech Mono", monospace',
              textShadow: !campaignName ? 'none' : '1px 1px 0px #E67E22'
            }}
            onMouseEnter={(e) => {
              if (campaignName) {
                e.target.style.transform = 'scale(1.05)';
                e.target.style.background = 'linear-gradient(135deg, #F39C12, #E67E22)';
              }
            }}
            onMouseLeave={(e) => {
              if (campaignName) {
                e.target.style.transform = 'scale(1)';
                e.target.style.background = 'linear-gradient(135deg, #F1C40F, #F39C12)';
              }
            }}
          >
            ⚡ UPDATE
          </button>
        </div>
      </div>
    </>
  );
}
